import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit } from '@angular/core';
import { NbMenuModule, NbSpinnerModule } from '@nebular/theme';
import { CommonModule } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { UserService } from '../../services/user.service';
import { MenuStore } from '../../../core/store/menu.store';

@Component({
  selector: 'ngx-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  standalone: true,
  imports: [CommonModule, NbMenuModule, NbSpinnerModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarComponent implements OnInit {
  readonly menuStore = inject(MenuStore);
  private destroyRef = inject(DestroyRef);

  constructor(private userService: UserService) {}

  ngOnInit(): void {
    this.initializeAutoCreate();
  }

  private initializeAutoCreate(): void {
    this.userService
      .autoCreate()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe();
  }
}
